import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import React, { useCallback } from "react";
import { slide as Menu } from 'react-burger-menu';
import { useDispatch, useSelector } from "react-redux";
import { isSidebarMenuOpen, closeMenu, toggleMenu } from "../store.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function MenuButton(_ref) {
  var className = _ref.className;
  var dispatch = useDispatch();
  var onClickHandler = useCallback(function () {
    dispatch(toggleMenu());
  }, [dispatch]);
  return /*#__PURE__*/_jsx("button", {
    className: className,
    onClick: onClickHandler,
    children: "Menu"
  });
}
MenuButton.propTypes = {
  className: PropTypes.string
};
export function SidebarPanel(props) {
  var dispatch = useDispatch();
  var isOpen = useSelector(isSidebarMenuOpen);
  var onCloseHandler = useCallback(function () {
    dispatch(closeMenu());
  }, [dispatch]);
  return /*#__PURE__*/_jsx(Menu, _objectSpread(_objectSpread({}, props), {}, {
    isOpen: isOpen,
    onClose: onCloseHandler
  }));
}